<template>
  <div style="height: inherit;">
    <Header />
    <div class="signupd__postion"style="position: absolute; width: 100%; min-width: 100%;">
      <div class="content__positioning distancing text signupdriver__content" style="min-height: 80%;">
      
        <div class="headlin-text">
          <div v-if="pageIndex < 4" class="adway_headers" style="margin-bottom: 60px;">Hello, welcome to Adway!</div>
          <div v-else style="margin-bottom: 60px;">Congratulations!</div>
        </div>
        <div v-if="pageIndex == 0" style="min-height: 27em;"><personal-info :driver='driver' @changeDriver='changeDriver($event)' ref="page1"></personal-info></div>
        <div v-else-if="pageIndex == 1" style="min-height: 27em;"><car-info :driver='driver' @changeDriver='changeDriver($event)' ref="page2"></car-info></div>
        <div v-else-if="pageIndex == 2" style="min-height: 27em;"><driving-info :driver='driver' @changeDriver='changeDriver($event)' ref="page3"></driving-info></div>
        <div v-else-if="pageIndex == 3" style="min-height: 27em;" ><document-info :driver='driver' @changeDriver='changeDriver($event)' ref="page4"></document-info></div>
        <div v-else style="min-height: 27em;"><confirmation-component :driver='driver'></confirmation-component></div>
        <div class="buttons-driver-sign-up" v-if="!isMobile()">
          <button @click="$router.go(-1)" v-if="pageIndex < 4" class="adway-btn-2-class button-spacing">
            <span class="btn__text__normal">Cancel</span>
          </button>
          <button @click="buttonBack" v-if="pageIndex > 0 && pageIndex < 4" class="adway-btn-3-class button-spacing">
            <div class="btn__context btn__context__reverse">
              <img src="./../../../assets/left-arrow.png" alt="left arrow" class="next__image__x">
              <span class="btn__text__bold" style='padding-left: 22px;'>Back</span>
            </div>
          </button>
          <button @click="buttonNext" v-if="pageIndex < 3" class="button-spacing" v-bind:class="[pageIndex == 0 ? 'adway-btn-class' : 'adway-btn-3-class']">
            <div class="btn__context">
                <span class="btn__text__bold btn__name__left">Next</span>
                <img src="./../../../assets/right-arrow.png" alt="left arrow" class="btn__next__img">
            </div>
          </button>
          <vue-recaptcha v-if="pageIndex == 3 && !isDebug()" :sitekey='config.googleRecaptcheSiteKey' style="display: inline-block;">
            <button v-if="pageIndex == 3" @click="buttonNext" class="adway-btn-4-class button-spacing" v-bind:class="[driverSingUpSpinner ? 'spinner__button' : '']">
              <clip-loader :loading="driverSingUpSpinner" :color="'#fff'"/>
              <div v-if="!driverSingUpSpinner" class="btn__context">
                <span class="btn__text__bold btn__name__left">Finish</span>
                <img src="./../../../assets/right-arrow.png" alt="left arrow" class="finnish__image">
              </div>
            </button>
          </vue-recaptcha>
          <button v-if="pageIndex == 3 && isDebug()" @click="buttonNext" class="adway-btn-4-class button-spacing" v-bind:class="[driverSingUpSpinner ? 'spinner__button' : '']">
            <clip-loader :loading="driverSingUpSpinner" :color="'#fff'"/>
            <div v-if="!driverSingUpSpinner" class="btn__context">
              <span class="btn__text__bold btn__name__left">Finish</span>
              <img src="./../../../assets/right-arrow.png" alt="left arrow" class="finnish__image">
            </div>
          </button>
          <button @click="homeButtonClick" v-if="pageIndex == 4" class="adway-btn-5-class">
            <span class="btn__text__bold">Home</span>
          </button>
          <router-link  class="router-link-home" to="/" style="display: none;">Home</router-link>
          <button @click="goToDriverAccount" v-if="pageIndex == 4" class="adway-btn-class" style="height: 5em; margin-left: 15px;">
            <span class="btn__text__bold">Go to my account </span>
          </button>
      </div>
      <div v-else>
         <button @click="buttonNext" v-if="pageIndex < 3" class="button-spacing" v-bind:class="[pageIndex == 0 ? 'adway-btn-class' : 'adway-btn-3-class']">
            <div class="btn__context">
                <span class="btn__text__bold btn__name__left">Next</span>
                <img src="./../../../assets/right-arrow.png" alt="left arrow" class="btn__next__img">
            </div>
          </button>
          <vue-recaptcha v-if="pageIndex == 3 && !isDebug()" :sitekey='config.googleRecaptcheSiteKey'>
            <button v-if="pageIndex == 3" @click="buttonNext" class="adway-btn-4-class button-spacing" v-bind:class="[driverSingUpSpinner ? 'spinner__button' : '']">
              <clip-loader :loading="driverSingUpSpinner" :color="'#fff'"/>
              <div v-if="!driverSingUpSpinner" class="btn__context">
                <span class="btn__text__bold btn__name__left">Finish</span>
                <img src="./../../../assets/right-arrow.png" alt="left arrow" class="finnish__image">
              </div>
            </button>
          </vue-recaptcha>
          <button v-if="pageIndex == 3 && isDebug()" @click="buttonNext" class="adway-btn-4-class button-spacing" v-bind:class="[driverSingUpSpinner ? 'spinner__button' : '']">
            <clip-loader :loading="driverSingUpSpinner" :color="'#fff'"/>
            <div v-if="!driverSingUpSpinner" class="btn__context">
              <span class="btn__text__bold btn__name__left">Finish</span>
              <img src="./../../../assets/right-arrow.png" alt="left arrow" class="finnish__image">
            </div>
          </button>
          <button @click="buttonBack" v-if="pageIndex > 0 && pageIndex < 4" class="adway-btn-3-class button-spacing">
            <div class="btn__context btn__context__reverse">
              <img src="./../../../assets/left-arrow.png" alt="left arrow" class="next__image__x">
              <span class="btn__text__bold" style='padding-left: 22px;'>Back</span>
            </div>
          </button>
          <button @click="$router.go(-1)" v-if="pageIndex < 4" class="adway-btn-2-class button-spacing">
            <span class="btn__text__normal">Cancel</span>
          </button>
          <button @click="goToDriverAccount" v-if="pageIndex == 4" class="adway-btn-class" style="height: 5em; margin-left: 15px;">
            <span class="btn__text__bold">Go to my account </span>
          </button>
          <button @click="homeButtonClick" v-if="pageIndex == 4" class="adway-btn-5-class">
            <span class="btn__text__bold">Home</span>
          </button>
          <router-link  class="router-link-home" to="/" style="display: none;">Home</router-link>
      
      </div>
    </div>
    <footer-view style="position: relative; bottom: 0;"></footer-view>
  </div>
  </div>
</template>

<script>
import PersonalInfo from './../../../components/footer/singup/driver/PersonalinfoComponent.vue'
import CarInfo from './../../../components/footer/singup/driver/CarinfoComponent.vue'
import DrivingInfo from './../../../components/footer/singup/driver/DrivinginfoComponent.vue'
import DocumentInfo from './../../../components/footer/singup/driver/DocumentInfoComponent.vue'
import ConfirmationComponent from './../../../components/footer/singup/driver/ConfirmationComponent.vue'
import Driver from './../../../plugins/utils/Driver.js'
import Header from './../../../components/design/HeaderDesign'
import HTTPRequest from './../../../plugins/utils/HttpRequest.js'
import Config from './../../../plugins/utils/Config.js'
import FooterView from './../../../components/footer/FooterView.vue'
import toast from '@utils/toast'
import store from '@store/index.js'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
// import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'SignUpDriver',
  components: {
    PersonalInfo,
    CarInfo,
    DrivingInfo,
    DocumentInfo,
    ConfirmationComponent,
    // VueRecaptcha,
    Header,
    FooterView,
    ClipLoader
  },
  data: function () {
    return {
      pageIndex: 0,
      driver: new Driver(),
      config: Config,
      image: 'driver',
      driverSingUpSpinner: false,
      response: null,
      store: store
    }
  },
  methods: {
    buttonBack () {
      this.pageIndex--
    },
    buttonNext () {
      if (this.pageIndex === 0) {
        this.$refs.page1.changeSomeDriverSettings()
      } else if (this.pageIndex === 1) {
        this.$refs.page2.changeSomeDriverSettings()
      } else if (this.pageIndex === 2) {
        this.$refs.page3.changeSomeDriverSettings()
      } else if (this.pageIndex === 3) {
        this.$refs.page4.changeSomeDriverSettings()
      }
    },
    finishSingUp () {
      var request = new HTTPRequest()
      var url = '/user/create'
      var body = {
        user: this.driver.email,
        API_KEY: '',
        data: {
          driver: 1,
          secret: this.driver.password
        }
      }
      
      var self = this
      request.makeRequest('POST', url, body).then((result) => {
        var jsonobject = JSON.parse(result)
        if (jsonobject.code === 0){
          toast.simpleMessage('Profile created')
          self.response = jsonobject
          this.editUser(jsonobject.token)
        } else {
          this.driverSingUpSpinner = false
          toast.errorMessage(jsonobject.message)
          if (jsonobject.message === 'User exists') {
            setTimeout(() => {
              toast.simpleMessage('Please change your email')
              this.pageIndex = 0
            }, 2000)
          }
        }
      }).catch((err) => {
        this.driverSingUpSpinner = false
        toast.responseMessageError(`${err} creating user`)
      })
    },
    editUser (token) {
      var request = new HTTPRequest()
      var url = this.config.address + '/set/profile'
      var body = {
        user: this.driver.email,
        code: token,
        API_KEY: this.config.api_key,
        data: {
          firstname: this.driver.name,
          surname: this.driver.surname,
          phone: this.driver.phoneNumber,
          car_make: this.driver.carBrand,
          car_model: this.driver.carModel,
          car_year: parseInt(this.driver.carYear),
          car_color: this.driver.carColorRGB,
          driving_per_week: parseInt(this.driver.drivingHours),
          lat: 0.0,
          lon: 0.0,
          ride_time: this.driver.drivingTime,
          platforms: this.driver.drivingPlatform,
          ADWAY_notifications: this.driver.notification ? 1 : 0,
          state: this.driver.usState,
          city: this.driver.usCity,
        }
      }
    
      var formData = new FormData()
      // this.driver.printData()
      formData.append('json', JSON.stringify(body))
      formData.append('driver_license_picture', this.driver.driverLicenceImage)
      formData.append('insurance_picture', this.driver.driverInsuranceImage)
      formData.append('rating_picture', this.driver.driverRating)
      formData.append('side_picture', this.driver.sideImage)
      request.makeRequestFormData('POST', url, formData).then((response) => {
        this.driverSingUpSpinner = false
        var jsonParse = JSON.parse(response)
        if (jsonParse.code === 0) {
          toast.successMessage('User create successful')
          setTimeout(() => {
            this.pageIndex++
          }, 800)
        } else {
          toast.errorMessage(jsonParse.message)
        }
      }).catch((err) => {
        toast.responseMessageError(`${err} setting user profile`)
        this.driverSingUpSpinner = false
      })
    },
    goToDriverAccount () {
      this.store.commit('setToken', this.response)
      this.getProfile()
    },
    getProfile () {
      var request = new HTTPRequest()
      var url = '/get/profile'
      var body = {
        user: this.driver.email,
        code: store.state.token.token,
        API_KEY: ''
      }
      request.makeRequest('POST', url, body).then((response) => {
        var jsonparse = JSON.parse(response)
        if (jsonparse.code === 0) {
          this.store.commit('setUser', jsonparse.data[0])
          this.$router.push('/driver/account')
        } else {
          toast.errorMessage(jsonparse.message)
        }
      }).catch((error) => {
      })
    },
    changeDriver (driver) {
      this.driver = driver
      if (this.pageIndex === 3) {
        this.driverSingUpSpinner = true
        this.finishSingUp()
      } else {
        this.pageIndex++
      }
    },
    homeButtonClick () {
      const routerLinkHome = document.getElementsByClassName('router-link-home')[0]
      routerLinkHome.click()
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>

.btn__context{
  padding: 0px calc(50% - 32px) 0px calc(50% - 49px);
  position: relative;
}

.btn__context__reverse{
  padding: 0px calc(50% - 49px) 0px calc(50% - 49px);
  position: relative;
}

.btn__name__left {
  padding-right: 5px;
}

.btn__next__img {
  position: absolute;
  width: 19px;
  top: 2px;
}

.next__image__0 {
  position: absolute;
  right: 94px;
  width: 19px;
  left: 155px;
  top: 21px;
}

.next__image__x {
  position: absolute;
  width: 19px;
  margin-top: 2px;
}

.finnish__image{
  position: absolute;
  width: 19px;
  margin-top: 2px;
}

.spinner__button {
  position: relative;
  top: 14px;
}

</style>